<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">“I did </span><span style=" font-weight: bold; font-style: italic; font-size: 1.17em;">write</span><span style=" font-weight: bold; font-size: 1.17em;"> the scene,” Steve pointed out, getting ready to pull his polo on over his undershirt.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Nina fixed him with a deadpan look.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Steve paused and made an apologetic face. “Sorry. Carry on.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Thank you. Although point taken. Mel, Adam—Morgan’s face when the door opens is key to setting the tone for the rest of the movie. I need you to get it on the first shot, or we’re going to have to have Drew strip naked.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Hey!” Steve protested. Drew and Nina looked at him, and he shrugged. “Give me some credit. I’m an amateur, but I think I can fake attraction to—” He gestured to Drew.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight"><span style=" font-style: italic; font-size: 1.00em;">Fake?</span> Damn. But, well, it wasn’t like Drew dated anyway. “Ouch.” He pressed a hand to his chest.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Check your ego,” Nina admonished. “Not everyone wants to see you in the buff. Now let’s get this set up. Where’s that extra?”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?7a02822a